import { ConfigurationComplementsCreateListPage } from './../../../../configuration/configuration-complements/configuration-complements-create/configuration-complements-create-list/configuration-complements-create-list';
import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { DishServices } from '../../../../dish/services';
import { Globals } from '../../../../../globals';
import { MenuServices } from '../../../../menu/services';
import { AnalyticsServices } from '../../../../services/analyticsServices';
import { ConfigurationServices } from '../../../../configuration/services';

/**
 * Generated class for the ComboPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-complements-partial-dishes-select',
    templateUrl: 'complements-partial-dishes-select.html',
})
export class ComplementsPartialDishesSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        public menuServices: MenuServices,
        public analyticsServices: AnalyticsServices,
        public configurationService: ConfigurationServices,
        public modalCtrl: ModalController) {
    }

    ionViewDidLeave() {
        this.configurationService.complements_selected = [];
        this.configurationService.complements_array_filtered = [...this.configurationService.complements_array_tmp];
        this.configurationService.complements_searchbar_text = '';
    }

    insert(element) {
        //Funcion que añadir al array de elementos seleccionados para el menu
        if (!this.check(element.UID)) { //Buscamos si el elemento ya esta anadido
            this.configurationService.complements_selected.push(element);
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-ingrediente-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.configurationService.complements_selected.length; i++) {
            var obj = this.configurationService.complements_selected[i];
            if (obj.UID == value) {
                response = true;
            }
        }
        return response;
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }

    createNewComplement() {
        this.navCtrl.push(ConfigurationComplementsCreateListPage, {
            type: 'all',
            callback: (data) => {
                if (data) {
                    this.configurationService.complements_selected.push(data);
                    this.configurationService.complements_array_filtered.push(data);
                    this.configurationService.complements_array_filtered = [...this.configurationService.complements_array_filtered];
                    this.configurationService.complements_array_tmp.push(data);
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/complements/complements-partial-select/complements-create-dish-select/complements-partial-dishes-select/complements-partial-dishes-select.ts